import { Mail, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer className="mt-16 py-6 border-t border-border/20 bg-background/50">
      <div className="container mx-auto px-6">
        <div className="text-center space-y-3">
          <div className="flex items-center justify-center space-x-2">
            <span className="text-green-400 font-medium">Cooked by</span>
            <span className="text-white font-bold text-lg">Nairoke</span>
            <span className="text-xs text-green-400/60">™</span>
            <span className="text-green-400/80">2025</span>
          </div>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-sm text-green-400/80">
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <a
                href="mailto:tubosun@nairoke.com"
                className="hover:text-green-400 transition-colors"
              >
                tubosun@nairoke.com
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Phone className="h-4 w-4" />
              <a
                href="tel:+2348109385214"
                className="hover:text-green-400 transition-colors"
              >
                +234 810 938 5214
              </a>
            </div>
          </div>

          <div className="pt-2 border-t border-border/10">
            <p className="text-xs text-muted-foreground">
              Professional Karaoke Management System
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
